import { defineComponent as t, openBlock as o, createBlock as r, normalizeProps as a, guardReactiveProps as n, withCtx as h, renderSlot as p, createElementVNode as m } from "vue";
import l from "../CdrIcon.vue.mjs";
const s = /* @__PURE__ */ m("path", {
  role: "presentation",
  d: "M15.74 11.002c.202 0 .375.165.375.375s-.165.375-.375.375h-.75a.371.371 0 01-.375-.375c0-.21.165-.375.375-.375h.75zm1.125-1.387c.217.127.375.36.375.645v2.25a.74.74 0 01-.375.63v.862a.76.76 0 01-.375.638v.195c0 2.572-1.973 4.665-4.395 4.665h-.06c-1.98 0-3.728-1.418-4.245-3.442L6.155 9.645c-.375-1.463-.06-3.03.847-4.2.833-1.073 2.07-1.695 3.39-1.695h1.703c2.287 0 4.17 1.875 4.38 4.26l.007.105c.225.127.383.36.383.637v.863zm-1.125 5.213h-.008v-.068h-.75v.082c0 1.748-1.297 3.165-2.895 3.165-1.35 0-2.497-.952-2.85-2.317L7.595 9.278c-.255-1.02-.038-2.108.592-2.91.555-.72 1.343-1.118 2.205-1.118h1.703c1.462 0 2.662 1.2 2.85 2.752h.75C15.5 6.037 13.962 4.5 12.087 4.5h-1.702c-1.08 0-2.1.51-2.798 1.41a4.118 4.118 0 00-.712 3.547l1.642 6.413c.435 1.695 1.883 2.88 3.518 2.88h.06c2.01 0 3.645-1.762 3.645-3.922zm.375-6.075h-1.5v.75h1.5v-.75zm-2.25 4.387a.811.811 0 01-.39-.638v-2.25a.75.75 0 01.375-.637v-.863c0-.262.15-.487.36-.622 0-.06-.008-.12-.015-.12C14.022 6.87 13.145 6 12.087 6h-1.702c-.623 0-1.2.293-1.613.825a2.66 2.66 0 00-.45 2.265l1.65 6.42c.263 1.028 1.11 1.748 2.063 1.748 1.245 0 2.205-1.088 2.205-2.423v-.195a.75.75 0 01-.375-.638v-.862zm2.25.862v-.75h-1.5v.75h1.5zm.375-1.5v-2.25h-2.25v2.25h2.25z"
}, null, -1), u = /* @__PURE__ */ t({
  name: "ExperiencesClimbing",
  __name: "experiences-climbing",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (c, v) => (o(), r(l, a(n(e.props)), {
      default: h(() => [p(c.$slots, "default"), s]),
      _: 3
    }, 16));
  }
});
export {
  u as default
};
